import authService from './AuthService';
import { configuration } from "../authConfig";

const logController = "log";
const headers = {
    'Content-Type': 'application/json',
    'Accept': '*/*',
    'Accept-Encoding': 'gzip,deflate,br',
    'Accept-Charset': 'utf-8',
    'Accept-Language': 'en-US'
  };


export class LogService {

  
  getUrl(action, controller) {
    var serviceurl = configuration.baseUri;
    return `${serviceurl}/api/${controller}/${action}`;
  }

  async getCertificate(dataSource, instanceId, authorityId, requestId, certType) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`certificate/${dataSource}/${instanceId}/${authorityId}/${requestId}/${certType}`, logController);

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        const ct = response.headers.get('content-type') || '';
        let message = `Certificate request failed (${response.status} ${response.statusText})`;
        try {
          if (ct.includes('application/json')) {
            const data = await response.json();
            if (data && (data.text || data.title || (data.issue && data.issue[0] && data.issue[0].details)))
              message = data.text || data.title || data.issue[0].details || message;
          } else {
            const text = await response.text();
            if (text && text.length > 0 && text.length < 500)
              message = text;
          }
        } catch (e) {
          console.error(e);
        }
        console.error(message);
        window.alert(message);
        return;
      }

      const blob = await response.blob();
      if (blob != null && blob !== undefined && blob.size > 0) {
        const filename = `VaxCertificate-${authorityId}-${requestId}.pdf`;
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = objectUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
      } else {
        const msg = 'Certificate download was empty.';
        console.error(msg);
        window.alert(msg);
      }
    } catch (error) {
      if (error !== undefined)
        console.error(error);
    }
  }

  async getRequestFile(dataSource, authorityId, requestId) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`requestcommand/${dataSource}/${authorityId}/${requestId}`, logController);

    fetch(url, {
      method: 'GET',
      headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
    })
      .then(response => response.blob())
      .then(blob => {
        let filename = `ImmucertRequest-${authorityId}-${requestId}.json`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;

        // the filename you want
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        if (error !== undefined)
          console.error(error);
      });
  }

  async getDetails(dataSource, authorityId, requestId) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`details/${dataSource}/${authorityId}/${requestId}`, logController);

    return fetch(url, {
        method: 'GET',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      })
      .then(response => response.json())
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });
  }

  async getTestResult(dataSource, instanceId, authorityId, requestId) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`test/${dataSource}/${instanceId}/${authorityId}/${requestId}`, logController);

    return fetch(url, {
        method: 'GET',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      })
      .then(response => response.json())
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });
  }

  async getList(search) {
    console.log(`Sending post data ${JSON.stringify(search)}`)
    console.log(`Sending post data ${JSON.stringify(search)}`)

    const token = await authService.getAccessToken();
    const url = this.getUrl('list', logController);
    console.log(url);

    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(search),
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });

    if (response !== undefined) {
      const data = await response.json();
      return data;
    }

    return [];
  }

  async getRecent(dataSource, authorityId, topcount) {
    console.log(`Getting recent log entries for ${authorityId} ${topcount} ${this.logController}`);

    const token = await authService.getAccessToken();
    const url = this.getUrl(`recent/${dataSource}/${authorityId}/${topcount}`, logController);
    console.log(url);

    const response = await fetch(url, {
        method: 'GET',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });
    const data = await response.json();
    return data;
  }

  async getRequest(dataSource, authorityId, requestId) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`requestentry/${dataSource}/${authorityId}/${requestId}`, logController);

    return fetch(url, {
      method: 'GET',
      headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` }
    })
      .then(response => response.json())
      .then(data => {
        return data;
      })
      .catch(e => {
        console.log(`Error in fetch error ${e}`);
        return;
      });
  }

  // Sends a request to the server to generate a certificate and download it
  // Allows sending to a different server instance than the one the user is currently logged in toicloude
  async postRequest(serverInstanceId, authorityId, request) {
    const token = await authService.getAccessToken();
    const url = this.getUrl(`send/${serverInstanceId}/${authorityId}`, logController);
    const content = {
        method: 'POST',
        headers: !token ? headers : { ...headers, 'Authorization': `Bearer ${token}` },
        //body: request
        body: JSON.stringify(JSON.parse(request).request)
      }

    fetch(url, content)
      .then(response => response.blob())
      .then(blob => {
        let filename = `VaxCertificate-${authorityId}.pdf`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;

        // the filename you want
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        if (error !== undefined)
          console.error(error);
      });
  }

  static get instance() { return logService }
}

const logService = new LogService();

export default logService;